import { useState, useEffect } from "react"
import { PREFERENCES_CHANGE_EVENT } from "../const/preferences"
import { readPreferences } from "../utilities/preferences"

/**
 * Reactive view of the user's display/sync preferences (see the Settings page).
 * Updates on same-tab changes (preferencesChange event) and cross-tab changes
 * (storage event).
 *
 * @returns {{ mapStyle: string, locationRefreshMinutes: number }}
 */
export function usePreferences() {
    const [preferences, setPreferences] = useState(readPreferences)

    useEffect(() => {
        const sync = () => {
            const next = readPreferences()
            setPreferences((previous) =>
                previous.mapStyle === next.mapStyle &&
                previous.locationRefreshMinutes === next.locationRefreshMinutes
                    ? previous
                    : next,
            )
        }

        window.addEventListener(PREFERENCES_CHANGE_EVENT, sync)
        window.addEventListener("storage", sync)
        return () => {
            window.removeEventListener(PREFERENCES_CHANGE_EVENT, sync)
            window.removeEventListener("storage", sync)
        }
    }, [])

    return preferences
}
